import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useNotify,useRoute } from "./Utils";
import { VerificationExpired } from "./VerifyRegistration";



export default function TokenValidate() {
  
  const navigate = useNavigate()
  const notify = useNotify()
  const createRoute = useRoute()

        useEffect(() => {
            const querystring = window.location.search;
            const urlparams = new URLSearchParams(querystring);
            const token = urlparams.get("token")
            const path = urlparams.get("path")
            const redirect_to = urlparams.get("redirect_to")

            
              
                const main = async() => {
                  if (token) {
                    try {
                      const fetching = await fetch(`${process.env.REACT_APP_API_URL}/${path}?token=${token}`,{"credentials": "include"})
                      const response = fetching.ok ? await fetching.json() : null
                        if (!fetching.ok) {
                          createRoute("/linkexpired",VerificationExpired)
                          navigate("/linkexpired")
                          return;
                        }
                        else if (fetching.ok) {
                          if (redirect_to === "resetpassword") {
                            navigate(`/${redirect_to}/${token}`)
                            return;
                          }
                          notify({message: response,variant: "success",duration: 2000})
                          navigate("/")
                          return;
                        }
                      }
                    catch(error) {
                      notify({message: "cant sync with server please try again later",variant: "error",duration:2000});
                      console.log(error);
                      return;
                      }
                  }
                }
                main();
                
              
                  
          },[])
    
}
